import React, { useState, useEffect } from "react";

import { Grow } from '@material-ui/core';

import TopBar from "../../Layouts/Topbar";
import Body from "../../Layouts/Body";
import Loading from "../../Layouts/Loading";

import PageImage from "./PageImage";

import {
    useParams
} from "react-router-dom";
import ContactForm from "../../Components/Property/ContactForm";
import ChaveLusaMap from "../../Components/Map";

const Page = ({ selfService }) => {
    let { id } = useParams();

    // Loading
    const [loading, setLoading] = useState(true);

    // Data from API
    const [page, setPage] = useState(null);
    useEffect(() => {
        let query_id = selfService ? "procura-" + id : id;

        console.log("ID", id);

        if (selfService && !id) {
            setLoading(false);
            return;
        }

        fetch(process.env.REACT_APP_API + "/pages/statics/" + query_id)
            .then(res => res.json())
            .then(json => {
                console.log("ERRIRIRIRIR", json)

                // 404 Error
                if ('detail' in json) {
                    if (window.location.pathname !== "/404") {
                        window.location.href = "/404";
                    } else {
                        setLoading(false);
                        setPage(null);
                    }
                } else {
                    setPage(json);
                    setLoading(false);
                }
            })
            .catch((error) => {
                console.log("ERRIRIRIRIR")
                setLoading(false);
                setPage(null);
            });
    }, [id]);

    return (
        <div>
            {
                !loading && page && page.widgetImage && page.widgetImage.length > 0 ?
                    <Grow
                        in={!loading}
                    >
                        <PageImage
                            image={page.widgetImage[0].image}
                        />
                    </Grow>
                    : !loading && page && page.widgetMap && page.widgetMap.length > 0 ?
                        <ChaveLusaMap coordinates={page.widgetMap[0].coordinates.split(",").map(Number)} explicit={true} />
                    : <div></div>
            }

            <TopBar>
                <h4 class="font-weight-bold text-light mb-0">
                    {
                        !loading &&
                        <>
                            {
                                page
                                    ?
                                    page.title
                                    :
                                    selfService
                                        ? "Que imóvel procura?"
                                        : "Página não encontrada"
                            }
                        </>
                    }
                </h4>
            </TopBar>
            <Body>
                {
                    loading
                        // On loading show Loading gif
                        ?
                        <Loading />
                        // Otherwise, show page content
                        :
                        <Grow
                            in={!loading}
                        >
                            <div className="col-12 bg-white p-3 p-md-5">
                                {
                                    page
                                        ?
                                        <div
                                            className=""
                                            dangerouslySetInnerHTML={{ __html: page.content }}
                                        >
                                        </div>
                                        : !selfService
                                            ? <div
                                                className="p-2"
                                            >
                                                <p>
                                                    Lamentamos, mas a página a que está a tentar aceder não existe.
                                                </p>
                                                <p>
                                                    Isto pode ter acontecido por a página estar temporariamente desativada, ter mudado de nome ou mesmo já não existir.
                                                </p>
                                                <a href="/">
                                                    <button
                                                        className="btn btn-primary"
                                                    >
                                                        Voltar à página inicial
                                                    </button>
                                                </a>
                                            </div>
                                            : <div></div>
                                }

                                {
                                    selfService &&
                                    <ContactForm />
                                }
                            </div>

                        </Grow>
                }
            </Body>
        </div>
    );
}

export default Page;